import { render, staticRenderFns } from "./ScrollableContainer.vue?vue&type=template&id=2e2960a0"
import script from "./ScrollableContainer.vue?vue&type=script&lang=js"
export * from "./ScrollableContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports